import { HTTP } from '@/axios_api/http-common'

const state = {
    npt: []
}

interface IState {
    npt: any[]
}

const getters = {
    getAllNpt(state:IState) {
        return state.npt
    },
    getNptById:(state: IState) => (id: any) =>{
        let npt = null
        if(!state.npt)return;
        for (let index = 0; index < state.npt.length; index++) {
             if(state.npt[index].id == id) {
                npt = state.npt[index];
                 break;
             } 
        }
        return npt
    },
}

const mutations = {
    createNewNpt(state: IState, payload: any) {
        state.npt.push(payload)
    },
    setNptOperations(state: IState, payload: any) {
        state.npt = payload
    },
    updateNpt(state: IState, payload: any) {
        var indexToUpdate: number | null = 0
        state.npt.forEach((nptItem: any, index: any, budgetLineArray: any) => {
            if (payload.id === nptItem.id) {
                indexToUpdate = index
            }
        })
        state.npt.splice(indexToUpdate, 1, payload)
    },
    deleteNPTOperation(state: IState, deletedIds: Array<string>){
       state.npt = state.npt.filter(n => !deletedIds.includes(n.id.toString()));
    },
}

const actions = {
    createNptOperation({commit} : {commit: any}, payload: any) {
        return new Promise ((resolve, reject) => {
            HTTP.post('NPTOperation/create', payload).then((response: any) => {
                commit('createNewNpt', response.data.data)
                resolve(response)                
            }).catch((error: any) => {
                const errorData = error.response && error.response.data && error.response.data.data;

                const errorResponse: {
                    generalMessage: string;
                    errors: any[];  // Adjusted type to any[] to allow various error structures
                } = {
                    generalMessage: '',
                    errors: []
                };

                if (typeof errorData === 'string') {
                    // If error data is a string, set it as the general message
                    errorResponse.generalMessage = errorData;
                } else if (Array.isArray(errorData)) {
                    // If error data is an array, treat them as individual errors
                    errorResponse.errors = errorData;
                } else {
                    // Handle any other unexpected structures
                    errorResponse.generalMessage = 'An unknown error occurred';
                }
                reject(errorResponse)
            })
        })
    },
    fetchNptOperation({commit} : {commit:any}) {
        return new Promise((resolve, reject) => {
            HTTP.get('NPTOperation').then((response: any) => {
                commit('setNptOperations', response.data.data)
                resolve(response)
            }).catch((error: any) => {
                reject(error)
            })
        })
    },
    updateNPTOperation({commit}: {commit: any}, payload: any) {
        return new Promise ((resolve, reject) => {
            HTTP.put('NPTOperation/update/'+ payload.id, payload).then((response: any) => {
                commit('updateNpt', payload)
                resolve(response)
            }).catch((error: any) => {
                reject(error)
            })
        })
    },
    deleteNPTOperationAction({commit}: {commit: any}, ids: Array<string>){
        return new Promise ((resolve, reject) => {
            HTTP.delete('NPTOperation/delete', {data: ids}).then((response: any) =>{
                resolve(response)
                commit('deleteNPTOperation', ids)
            }).catch((error: any) => {
                reject(error)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}